import React, { useState } from "react";
import { Flex, ModalV2, Textarea } from "@jsq/ds/core";
import { SPACING } from "#utils/spacing";
import * as styles from "../styles_vanilla.css";

interface ReturnModalProps {
  isOpen: boolean;
  loading?: boolean;
  onCancel: () => void;
  onConfirm: (note: string) => void;
}

export const ReturnModal: React.FC<ReturnModalProps> = ({
  isOpen,
  loading = false,
  onCancel,
  onConfirm,
}) => {
  const [note, setNote] = useState("");

  const handleHide = () => {
    setNote("");
    onCancel();
  };

  const handleSubmit = () => {
    onConfirm(note);
    setNote("");
  };

  return (
    <ModalV2
      show={isOpen}
      onHide={handleHide}
      title="Return"
      size="medium"
      data-testid="return-modal"
    >
      <ModalV2.Body>
        <Flex flexDirection="column" gap={SPACING.LARGE}>
          <Textarea
            name="return-note"
            label="Note"
            value={note}
            onSetValue={setNote}
            placeholder="Please specify any additional feedback"
            isFullWidth
            size="medium"
          />
        </Flex>
      </ModalV2.Body>
      <ModalV2.Footer>
        <Flex justifyContent="flex-end" gap={SPACING.SMALL} className={styles.modalFooter}>
          <button
            className={styles.actionButton}
            onClick={handleHide}
            disabled={loading}
            data-testid="return-modal-cancel"
          >
            Cancel
          </button>
          <button
            className={styles.actionButtonPrimary}
            onClick={handleSubmit}
            disabled={loading}
            data-testid="return-modal-confirm"
          >
            Return
          </button>
        </Flex>
      </ModalV2.Footer>
    </ModalV2>
  );
};

export default ReturnModal;
